package empiresmp.components.fade.animation

import androidx.compose.runtime.mutableStateOf
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock

class Animatable(val initialValue: Float) {
    private val _value = mutableStateOf(initialValue)
    val value get() = _value.value
    private val mutex = Mutex()

    suspend fun animateTo(targetValue: Float, animator: Animator) {
        mutex.withLock {
            coroutineScope {
                animator.animate(
                    startValue = value,
                    endValue = targetValue,
                    onUpdate = { _value.value = it }
                )
            }
        }
    }
}
